import React, { useRef } from "react";
import PropTypes from "prop-types";
import Modal from "../../../../parts/modal-new";

const GroceryListModal = ({ locals }) => {
  const { query, mealPlanTemplates = [] } = locals;
  const { mealPlanId, week } = query.modal || {};
  const printRef = useRef(null);

  const template = mealPlanTemplates.find((t) => t._id === mealPlanId);
  const weekData = template?.weeks?.[week];
  const groceryListData = weekData?.groceryList;

  const data = groceryListData || {
    categories: [],
    mealPlanId,
    week,
  };

  const { categories = [] } = data;

  const handleExportPDF = () => {
    const printWindow = window.open("", "_blank");
    const printContent = printRef.current.innerHTML;

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Grocery List - Week ${parseInt(week) + 1}</title>
          <style>
            @media print {
              @page {
                margin: 1cm;
              }
            }
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
              color: #333;
            }
            h1 {
              font-size: 24px;
              margin-bottom: 20px;
              border-bottom: 2px solid #333;
              padding-bottom: 10px;
            }
            .category {
              margin-bottom: 30px;
              page-break-inside: avoid;
            }
            .category-title {
              font-size: 18px;
              font-weight: bold;
              margin-bottom: 15px;
              color: #333;
              border-bottom: 1px solid #ccc;
              padding-bottom: 5px;
            }
            .item {
              margin-bottom: 15px;
              padding-left: 20px;
            }
            .item-name {
              font-weight: bold;
              margin-bottom: 5px;
              text-transform: capitalize;
            }
            .item-quantity {
              margin-bottom: 5px;
              color: #666;
            }
            .item-source {
              font-size: 12px;
              color: #999;
              margin-top: 5px;
            }
            .item-usages {
              font-size: 11px;
              color: #777;
              margin-top: 5px;
              padding-left: 10px;
            }
            .usage-item {
              margin-bottom: 3px;
            }
          </style>
        </head>
        <body>
          <h1>Grocery List - Week ${parseInt(week) + 1}</h1>
          ${printContent}
        </body>
      </html>
    `);

    printWindow.document.close();
    setTimeout(() => {
      printWindow.print();
    }, 250);
  };

  return (
    <Modal
      className="grocery-list-modal"
      title={`Grocery List - Week ${parseInt(week) + 1}`}
    >
      <div className="body">
        <div className="grocery-list-content" ref={printRef}>
          {categories.length === 0 ? (
            <div className="empty-state">
              <p>No ingredients found for this week.</p>
            </div>
          ) : (
            categories.map((category, categoryIndex) => (
              <div key={categoryIndex} className="category">
                <h3 className="category-title">{category.name}</h3>
                <ul className="items-list">
                  {category.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="item">
                      <div className="item-name">{item.name}</div>
                      <div className="item-quantity">
                        {item.quantity}
                        {item.unit && ` ${item.unit}`}
                      </div>
                      <div className="item-source">
                        Source: {item.sourceName} ({item.sourceType})
                      </div>
                      {item.usages && item.usages.length > 0 && (
                        <div className="item-usages">
                          <strong>Used in:</strong>
                          <ul className="usages-list">
                            {item.usages.map((usage, usageIndex) => (
                              <li key={usageIndex} className="usage-item">
                                {usage.dayName} - {usage.mealType} (Meal{" "}
                                {usage.mealOrder})
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))
          )}
        </div>
        <footer>
          <button
            type="button"
            data-button-type="primary"
            onClick={handleExportPDF}
            disabled={categories.length === 0}
          >
            Export as PDF
          </button>
        </footer>
      </div>
    </Modal>
  );
};

GroceryListModal.propTypes = {
  locals: PropTypes.object,
};

export default GroceryListModal;
